import React from 'react';
import '../pages/OurClients.css';
import { Container, Row, Col, Image } from 'react-bootstrap';
import kotakLogo from '../assets/images/clients/kotak.png';
import avanseLogo from '../assets/images/clients/avanse.png';
import suryodayLogo from '../assets/images/clients/suryoday.png';
import axisLogo from '../assets/images/clients/axis.png';
import muthootLogo from '../assets/images/clients/muthoot.png';
import fedbankLogo from '../assets/images/clients/fedbank.png';
import highCourtLogo from '../assets/images/clients/high-court.png';

const CLIENTS = [
  { name: 'Kotak Mahindra Bank Ltd', logo: kotakLogo },
  { name: 'Avanse Finance Service Ltd', logo: avanseLogo },
  { name: 'Suryoday Small Finance Bank', logo: suryodayLogo },
  { name: 'Axis Bank', logo: axisLogo },
  { name: 'Muthoot Homefin', logo: muthootLogo },
  { name: 'Fedbank Financial Services Limited', logo: fedbankLogo },
  { name: 'High Court', logo: highCourtLogo, large: true },
];

function OurClients() {
  return (
    <Container fluid className="clientsContainer">
      <Row className="justify-content-center">
        <Col md={10} className="text-center">
          <h2 className="clientsHeading">Our Clients &amp; Partners</h2>
          <p className="clientsSubheading">
            Trusted by leading banks, financial institutions and judicial bodies across India.
          </p>
        </Col>
      </Row>

      <Row className="clientsCards g-4 justify-content-center">
        {CLIENTS.map(({ name, logo, large }) => (
          <Col xs={6} sm={4} md={3} key={name}>
            <div className="clientCard">
              <div className="clientLogoBox">
                <Image
                  src={logo}
                  alt={name}
                  className={`clientLogoImg${large ? ' clientLogoImgLarge' : ''}`}
                />
              </div>
            </div>
          </Col>
        ))}
      </Row>
    </Container>
  );
}

export default OurClients;
